import React, { useEffect, useRef, useState } from "react";
import Quill from "quill";
import BlotFormatter from "@enzedonline/quill-blot-formatter2";
import "quill/dist/quill.snow.css";
import useFileUploader from "../hooks/useFileUploader";
import "./editor.css";

Quill.register("modules/blotFormatter", BlotFormatter);

export default function Editor({ name, value, onChange }) {
  const { uploadImage } = useFileUploader();
  const editorRef = useRef(null);
  const quillInstance = useRef(null);

  //Check amount of document size
  function getByteSize(str) {
    return new Blob([str]).size; // gives byte size
  }

  function getbase()
  {
     import.meta.env.VITE_API_URL
                ? `${import.meta.env.VITE_API_URL}${res}`
                : `http://localhost:8000${res}`
  }

  const [docSize, SetDocSize] = useState("");

  const TextChange = (doc) => {
    //Get byte of text
    const sizeInBytes = getByteSize(doc);

    if (sizeInBytes > 65535) {
      SetDocSize("Maximum document size reached");
    } else {
      SetDocSize("");
    }
  };

  //
  useEffect(() => {
    if (quillInstance.current) {
      const currentContent = quillInstance.current.root.innerHTML;

      if (value && value !== currentContent) {
        // Preserve cursor
        const selection = quillInstance.current.getSelection();
        quillInstance.current.clipboard.dangerouslyPasteHTML(value);
        // Restore cursor
        if (selection) {
          quillInstance.current.setSelection(selection);
        }
      }
    }
  }, [value]);

  useEffect(() => {
    if (!editorRef.current || quillInstance.current) return;

    // ✅ Custom toolbar element
    const toolbarOptions = [
      ["bold", "italic", "underline", "strike"],
      [{ header: [1, 2, 3, false] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["image"],
    ];

    quillInstance.current = new Quill(editorRef.current, {
      theme: "snow",
      modules: {
        toolbar: {
          container: toolbarOptions, // only ONE toolbar
        },
        blotFormatter: {
          resize: { overlayStyles: { border: "2px dashed #333" } },
          align: { alignments: ["left", "center", "right"] },
        },
      },
    });

    // ✅ Image upload handler
    const toolbar = quillInstance.current.getModule("toolbar");
    toolbar.addHandler("image", () => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.click();

      input.onchange = async () => {
        const file = input.files?.[0];
        if (!file) return;

        try {
          const res = await uploadImage(file, "/product_edit_image", file.name);
          if (res) {
            const range = quillInstance.current.getSelection(true);
            quillInstance.current.insertEmbed(
              range.index,
              "image",
              import.meta.env.VITE_API_URL
                ? `${import.meta.env.VITE_API_URL}${res}`
                : `http://localhost:8000${res}`,
              "user"
            );
          }
        } catch (err) {
          console.error("Image upload failed", err);
        }
      };
    });

    quillInstance.current.on("text-change", () => {
      TextChange(quillInstance.current.root.innerHTML);
      onChange({
        target: { name, value: quillInstance.current.root.innerHTML },
      });
    });

    if (value) {
      quillInstance.current.root.innerHTML = value;
    }
  }, [name, onChange, uploadImage, value]);

  return (
    <div className="editor-wrapper">
      {/* ✅ Quill creates toolbar automatically here */}
      <div ref={editorRef} style={{ height: 300 }} />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <label>{docSize}</label>
        <label style={{ color: "indianred" }}>
          Maxium size of document : 64 KB
        </label>
      </div>
    </div>
  );
}
